

<div id="">
   <header id="banner" role="banner">
      <nav class="site-breadcrumbs" id="breadcrumbs">
         <!--<h1> <span>Elementi Navigazione</span> </h1>--> 
         <ul class="breadcrumbs breadcrumbs-horizontal lfr-component">
            <li class="first"><span><a routerLink="">SIRA</a></span></li>
            <li><span><a href="/sirang/servizionline">SERVIZI ONLINE</a></span></li>
            <li class="last"><span><a href="/sirang/monitoraggiambientali">Monitoraggi Ambientali</a></span></li>
         </ul>
      </nav>
   </header>
   <div id="content">
      <div class="portlet-boundary portlet-boundary_103_ portlet-static portlet-static-end " id="p_p_id_103_">
         <span id="p_103"></span> 
         <div class="portlet-body"> </div>
      </div>
      <div class="columns-2" id="main-content" role="main">
         <div class="portlet-layout">
            <div class="aui-w70 portlet-column" id="column-1">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-first" id="layout-column_column-1">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_BQJ6kkJtClvg_">
                     <span id="p_56_INSTANCE_BQJ6kkJtClvg"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_BQJ6kkJtClvg">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text portlet-title-editable" style="margin-left: 0px;">Monitoraggi ambientali</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article"> Il modulo permette la navigazione, la ricerca, la validazione e la gestione dei dati di misura acquisiti dalle stazioni di monitoraggio della qualità dell'aria, della qualità delle acque, dei parametri meteorologici e delle radiazioni elettromagnetiche. E' possibile consultare i dati tecnici delle stazioni e visualizzare i dati analitici giornalieri, mensili e annuali acquisiti dalle singole stazioni fisse e mobili. Per quanto riguarda i dati derivanti da reti di monitoraggio automatiche è stato, inoltre, realizzato uno specifico software, esterno al SIRA, strutturato per ricevere i dati dalle stazioni di monitoraggio e per gestire ed elaborare le informazioni relative alle centraline distribuite nel territorio regionale. </div>
                                    <div class="entry-links"> </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <form action="#" id="hrefFm" method="post" name="hrefFm"> <span></span> </form>
   </div>
</div>